import { Box, Heading, SimpleGrid } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import ArrowButton from '../../ui/ArrowButton';

interface Props {
  backgroundColor: string;
}

const ReadyToStartDesktop: React.FC<Props> = ({ backgroundColor }) => (
  <SimpleGrid
    d={{ base: 'none', desktop: 'grid' }}
    columns={2}
    bg={backgroundColor}
    spacing="auto"
    pl="100px"
    shadow="distance300"
  >
    <Box flexDir="column" alignItems="flex-start" maxW="xl" pt="103px">
      <Heading color="neutral.0" size={700}>
        Want to learn more?
      </Heading>
      <Heading
        maxW="sm"
        color="neutral.0"
        size={400}
        isDisplay
        marginBottom={800}
      >
        All about how HOVER helps you get the job done.
      </Heading>
      <ArrowButton
        as={GatsbyLink}
        to={`${process.env.GATSBY_V2_PREFIX}/how-it-works`}
        display="block"
        colorScheme="primary"
        type="button"
        w="auto"
      >
        LEARN MORE
      </ArrowButton>
    </Box>
    <Box
      position="relative"
      alignItems="flex-end"
      overflow="hidden"
      justifyContent="flex-end"
    >
      <StaticImage
        quality={100}
        placeholder="blurred"
        alt="home"
        src="../../../assets/images/invited_by_contractor_home.png"
      />
      <StaticImage
        quality={100}
        placeholder="blurred"
        height={340}
        alt="phone"
        src="../../../assets/images/want_to_learn_more_phone.png"
        style={{ position: 'absolute', bottom: 0, right: '120px' }}
      />
    </Box>
  </SimpleGrid>
);

export default ReadyToStartDesktop;
